module.exports = __webpack_public_path__ + "img/button.d6d41645.png";